export default "__VITE_ASSET__BBUg76qz__"